import { Link } from "react-router-dom";
import WomanProfileDetails from "../../../Components/WomanProfileDetails/WomanProfileDetails";
import { useTranslation } from "../../../i18n/LanguageProvider";
import { getWomanCategoryPath } from "../../../utils/slug";

function WomanProfileCard({ woman }) {
    const { t, localizedPath } = useTranslation();
    const categoryPath = getWomanCategoryPath(woman);

    return (
        <>
            <nav className="woman-page__breadcrumb">
                <Link to={localizedPath("/")}>{t("profile.home")}</Link>
                <span> / </span>
                {categoryPath && woman.category_name && (
                    <>
                        <Link to={localizedPath(categoryPath)}>{woman.category_name}</Link>
                        <span> / </span>
                    </>
                )}
                <span>
                    {woman.name} {woman.surname}
                </span>
            </nav>

            <WomanProfileDetails woman={woman} showExtras />
        </>
    );
}

export default WomanProfileCard;
